import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appUsers: [],
  allAppUsers: []
};

export const AppUsersSlice = createSlice({
  name: "appUsers",
  initialState,
  reducers: {
    getAllAppUsersAction: (state, action) => {
      
      state.allAppUsers = action.payload;
    },
    getSingleAppUsersAction: (state, action) => {
      
      state.appUsers = action.payload;
    },
  },
});

export default AppUsersSlice.reducer;

export const { getAllAppUsersAction, getSingleAppUsersAction } = AppUsersSlice.actions;
